import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import 'react-slideshow-image/dist/styles.css';
import { Slide } from 'react-slideshow-image';
import './CStyle.css';
import { css } from "styled-components/macro"; //eslint-disable-line

import { Link, animateScroll as scroll } from "react-scroll";

import slide1 from '../images/slide_1.png';
import slide2 from '../images/slide_2.png';
import slide3 from '../images/slide_3.png';
import background from '../images/home_background.jpg';

import { ReactComponent as ZapIcon } from "feather-icons/dist/icons/zap.svg";
import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

const Container = styled.div`
  ${tw`relative -mx-10 -mt-8 bg-center bg-cover`};
  background-image: url(${background});
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-700 opacity-75`;
const HeroContainer = tw.div`z-20 relative px-8 sm:pr-0 mx-auto 2xl:ml-12 2xl:mr-0`;
const Heading = styled.h1`
  ${tw`text-4xl text-center md:text-5xl sm:text-left sm:pl-10 2xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-primary-600 px-4 -mx-4 py-2`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;

const Description = tw.p`mt-10 pl-2 text-center text-lg md:text-xl sm:text-left sm:pl-5 font-medium leading-relaxed text-gray-500`;

const PrimaryAction = tw.button`px-8 py-3 mt-10 text-2xl sm:mt-16 sm:px-8 sm:py-4 bg-gray-100 text-primary-500 font-bold rounded shadow transition duration-300 hocus:bg-primary-500 hocus:text-gray-100 focus:shadow-outline`;

const Features = tw.div`mx-auto pt-6 md:mx-0 flex justify-center flex-row max-w-none`;
const Feature = tw.div`mt-10 px-5 md:px-0 lg:mt-8 flex items-center flex-col md:mr-8 last:mr-0`;

const FeatureHeadingContainer = tw.div`flex items-center`;
const FeatureIconContainer = styled.div`
  ${tw`mx-auto inline-block border border-primary-500 text-primary-500 text-center rounded p-2 flex-shrink-0`}
  ${props => [
    props.iconRoundedFull && tw`rounded-full`,
    props.iconFilled && tw`border-0 bg-primary-500 text-gray-100`
  ]}
  svg {
    ${tw`w-5 h-5`}
  }
`;
const FeatureHeading = tw.div`ml-3 font-bold text-xl`;

const PrimaryButton = styled(PrimaryButtonBase)(props => [
  tw`mt-4 text-sm inline-block mx-auto md:mx-0`,
  props.buttonRounded && tw`rounded-full`
]);

const features = [
  {
    Icon: ZapIcon,
    title: "Innovativo",
    description: "Grazie ad una moderna gamemode base e al nostro team di sviluppo, ti garantiamo svariate ore di divertimento giocando sul nostro server. Ovviamente siamo aperti alle proposte dell'utenza: assicurati di entrare nel nostro server discord, dove potrai anche trovare molte informazioni utili e interagire con la community.",
    iconContainerCss: tw`bg-primary-800 text-primary-400`
  },
  {
    Icon: MoneyIcon,
    title: "Gratuito",
    description: "Non pagherai un centesimo per giocare (a parte il costo del gioco base GTA San Andreas), a meno che tu non voglia donare per supportare il progetto! Infatti, San Andreas Multiplayer è completamente gratuito e ti basterà superare una breve whitelist per accedere al nostro server.",
    iconContainerCss: tw`bg-primary-800 text-primary-400`
  }
];

export default () => {

  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <div>
          <Slide easing="ease-out" arrows={false} indicators={() => <div className="indicator">•</div>} autoplay={true} infinite={true} duration={10000}>
            <div className="each-slide" style={{ transform: "translate(-5px)" }}>
              <div style={{ 'backgroundImage': `url(${slide1})` }}><Heading tw="pt-10">
                Sei atterrato<br />
                <SlantedBackground>su Rewind.</SlantedBackground><br />
                <span tw="pt-4">Goditi questo<br />momento.</span>
              </Heading>
                <Description className="slide-desc">
                  La tua ultima fermata prima di un'esperienza senza precedenti in una contea dove la criminalità è all'ordine del giorno e le amicizie sono fondamentali.<br />
                  Sarai il buono o sarai il cattivo? Contribuirai alla crescita della società oppure sarai un egocentrico in cerca di ricchezza?
                </Description>
                <Description className="slide-desc">Questa è la tua storia. Scrivila come preferisci.</Description>
              </div>
            </div>
            <div className="each-slide" style={{ transform: "translate(-5px)" }}>
              <div style={{ 'backgroundImage': `url(${slide2})` }}>
                <Heading tw="pt-10">
                  Designed & Developed<br />
                  <SlantedBackground>by Players.</SlantedBackground>
                </Heading>
                <Description className="slide-desc">
                  Che tu abbia lunghi anni di esperienza con il roleplay su SA:MP o meno non ha importanza, chiunque è il benvenuto su Rewind.<br />
                  Dalla nostra parte, possiamo vantare un'esperienza consolidata nel campo, che applichiamo ogni giorno nello sviluppo della gamemode, nella stesura dei regolamenti, nelle decisioni più importanti ma soprattutto nella nostra missione di offrire un'esperienza di gioco divertente, semplice e al tempo stesso innovativa.
                  <Features>
                    {features.map((feature, index) => (
                      <Feature key={index}>
                        <FeatureHeadingContainer>
                          <FeatureIconContainer
                            iconFilled={true}
                            iconRoundedFull={true}
                            css={feature.iconContainerCss || null}
                          >
                            {<feature.Icon />}
                          </FeatureIconContainer>
                          <FeatureHeading tw="text-primary-100">{feature.title}</FeatureHeading>
                        </FeatureHeadingContainer>
                        {index === 0 ?
                          <PrimaryButton buttonRounded={true} onClick={() => window.location.href = 'https://discord.gg/EfFFvX5qrP'}>
                            Entra nel discord
                          </PrimaryButton>
                          : index === 1 &&
                          <Link
                            activeClass="active"
                            to="section1"
                            spy={true}
                            smooth={true}
                            offset={-50}
                            duration={400}>
                            <PrimaryButton buttonRounded={true}>
                              Inizia a giocare
                            </PrimaryButton>
                          </Link>}
                      </Feature>
                    ))}
                  </Features>
                </Description>

              </div>
            </div>
            <div className="each-slide" style={{ transform: "translate(-5px)" }}>
              <div style={{ 'backgroundImage': `url(${slide3})` }}>
                <Heading tw="pt-10">
                  Alla scoperta di<br />
                  <SlantedBackground>Red County</SlantedBackground>
                </Heading>
                <Description className="slide-desc" tw="pt-6">
                  Un'ambientazione unica, completamente ricostruita dal nostro team.<br />
                  Red County è un'area rurale, attraversata da fiumi e popolata da laghi, colline e foreste: incarna alla perfezione il roleplay rivoluzionario di Rewind.<br />
                  Dillimore, Montgomery, Blueberry e Palomino Creek garantiscono all'utente un ampio ventaglio di sviluppi e trame intriganti.
                </Description>
                <div tw="flex justify-center sm:justify-start sm:pl-6 md:pl-12"><PrimaryAction>Scopri il server</PrimaryAction></div>
              </div>
            </div>
          </Slide>
        </div>
      </HeroContainer>
      <div id="section1" />
    </Container>
  );
}